import React, { Component } from "react"
import { initializeApp } from 'firebase/app'
import { getFirebaseConfig } from '../lib'
import { getFunctions, httpsCallable } from 'firebase/functions'

const app = initializeApp(getFirebaseConfig())

export default class OrderForm extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      items: props.initialItems || [],
      newItem: {
        productCode: "",
        description: "",
        quantity: 1,
        price: "",
        unitMeasurement: "",
        serviceCode: ""
      },
      products: [],
      loading: true,
      error: null
    }
    
    this.functions = getFunctions(app)
// Define dropdown options
    this.serviceCodeOptions = [
      { name: "Full Service", value: "F" },
      { name: "Self Service", value: "S" }, 
      { name: "Mini Service", value: "N" },
      { name: "Maxi Service", value: "Z" },
      { name: "Other", value: "O" }
    ]
    
    this.unitOfMeasureOptions = [
      { name: "Gallons", value: "G" },
      { name: "Case / Carton", value: "C" },
      { name: "Kilograms", value: "K" }, 
      { name: "Liters", value: "L" },
      { name: "Ounces", value: "O" },
      { name: "Pounds", value: "P" },
      { name: "Quarts", value: "Q" },
      { name: "Units", value: "U" },
      { name: "Undefined", value: "Z" }
    ]

  }

  async componentDidMount() {
    console.log('FLeetItems', this.props.initialItems)
    
    try {
      console.log('calling fetchFleetProducts')
      const fetchFleetProducts = httpsCallable(this.functions, 'onCall-fetchFleetProducts')
      const productscoll = await fetchFleetProducts()
      
      this.setState({
        products: productscoll.data,
        loading: false
      })
    } catch (error) {
      console.error('Error fetching products:', error)
      this.setState({
        error: error.message,
        loading: false,
        products: [] // Fallback to empty array
      })
    }
  }

  componentDidUpdate(prevProps) {
    // Update items if initialItems prop changes
    if (prevProps.initialItems !== this.props.initialItems) {
      this.setState({
        items: this.props.initialItems || []
      })
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target
    
    this.setState(prevState => ({
      newItem: {
        ...prevState.newItem,
        [name]: name === "quantity" || name === "price" ? (value ? Number(value) : 0) : value
      }
    }))
    console.log('handlechange', name, value)
  }

  handleProductChange = (e) => {
    const selectedNumber = e.target.value

    console.log('selectedNumber', selectedNumber)
    console.log('this.state.products', this.state.products)
    
    const selectedProduct = this.state.products.find(p => p.productCode === selectedNumber)
    console.log('selectedProduct', JSON.stringify(selectedProduct))
    // console.log('newItem', JSON.stringify(this.state.newItem))
    
    if (selectedProduct) {
      this.setState(prevState => ({
        newItem: {
          productCode: selectedProduct.productCode,
          description: selectedProduct.description,
          quantity: prevState.newItem.quantity,
          price: prevState.newItem.price,
          unitMeasurement: this.unitOfMeasureOptions[0].value, // Default to first option
          serviceCode: this.serviceCodeOptions[0].value // Default to first option
        }
      }))
    } else {
      /* this.setState({
        newItem: {
          productCode: "",
          description: "",
          quantity: 1,
          price: ""
        }
      }) */
    }
  }

  addItem = () => {
    const { newItem } = this.state
    console.log('addItem', newItem.productCode, newItem.description, newItem.quantity, newItem.price, newItem.serviceCode)
    
    if (!newItem.productCode || !newItem.description || !newItem.price || !newItem.serviceCode || !newItem.unitMeasurement) {
      return
    }

    this.setState(prevState => ({
      items: [...prevState.items, newItem],
      newItem: { 
        productCode: "", 
        description: "", 
        quantity: 1, 
        price: "", 
        unitMeasurement: "", 
        serviceCode: "" 
      }
    }))
  }

  removeItem = (index) => {
    this.setState(prevState => ({
      items: prevState.items.filter((_, i) => i !== index)
    }))
  }

  saveItems = () => {
    if (this.props.onSave) {
      this.props.onSave(this.state.items) // Pass array back to parent
    }
  }

  render() {
    const { items, newItem, products, loading, error } = this.state

    // Show loading state while fetching products
    if (loading) {
      return (
        <div style={{ maxWidth: "600px", margin: "0 auto", fontFamily: "Arial", textAlign: "center", padding: "20px" }}>
          <div>Loading products...</div>
        </div>
      )
    }

    // Show error state if products failed to load
    if (error) {
      return (
        <div style={{ maxWidth: "600px", margin: "0 auto", fontFamily: "Arial", textAlign: "center", padding: "20px" }}>
          <div style={{ color: "red" }}>Error loading products: {error}</div>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      )
    }

    const total = items.reduce(
      (sum, item) => sum + item.quantity * item.price,
      0
    )

    return (
      <div style={{ maxWidth: "800px", margin: "0 auto", fontFamily: "Arial" }}>
        {/* <div className="col text-start" style={{ color: '#36454F' }}><b>Add Items to Order</b></div> */}

        {/* First Row Headers */}
        <br/>
        <div className="col text-start" 
          style={{
            color: '#36454F', 
            display: "grid",
            gridTemplateColumns: "2fr",
            gap: "8px",
            marginBottom: "4px",
            fontWeight: "bold",
            textAlign: "center"
          }}>
          
          <div>Product / Description</div>
        </div>

        {/* First Row Inputs */}
        <div className="col text-start" style={{ fontSize: "14px", color: '#36454F', display: "grid", gridTemplateColumns: "2fr", gap: "8px", marginBottom: "8px" }}>
          
          <select style={{ borderRadius: '4px' }}
            className=""
            name="productCode"
            value={newItem.productCode}
            onChange={this.handleProductChange}
          >
            <option value="">Select Product</option>
            {products.map((p) => (
              <option key={p.productCode} value={p.productCode}>
                {p.productCode} - {p.description}
              </option>
            ))}
          </select>
        </div>
        
        {/* second Row Headers */}
        
        <div className="col text-start" 
          style={{
            color: '#36454F', 
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "8px",
            marginBottom: "4px",
            fontWeight: "bold",
            textAlign: "center"
          }}>
          
          <div>Service Code</div>
          <div>Unit of Measure</div>
        </div>

        {/* second Row Inputs */}
        <div className="col text-start" style={{ fontSize: "14px", color: '#36454F', display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginBottom: "8px" }}>
          
          <select
            style={{ borderRadius: '4px' }}
            className="bodytext"
            name="serviceCode"
            value={newItem.serviceCode}
            onChange={this.handleChange}
            required
          >
            <option value="">Select Service</option>
            {this.serviceCodeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
          
          
            <select
              style={{ borderRadius: '4px' }}
              className="bodytext"
              name="unitMeasurement"
              value={newItem.unitMeasurement}
              onChange={this.handleChange}
              required
            >
              <option value="">Select Unit</option>
              {this.unitOfMeasureOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
            </select>
          
        </div>

        {/* third Row Headers */}
        <div className="col text-start" 
          style={{
            color: '#36454F', 
            display: "grid",
            gridTemplateColumns: ".5fr .5fr .5fr",
            gap: "8px",
            marginBottom: "4px",
            fontWeight: "bold",
            textAlign: "center"
          }}>
          
          <div>Qty</div>
          <div>Price</div>
          <div></div>
        </div>

        {/* third Row Inputs */}
        <div className="col text-start" style={{ fontSize: "14px", color: '#36454F', display: "grid", gridTemplateColumns: ".5fr .5fr .5fr", gap: "8px", marginBottom: "16px" }}>
          
          <div className="">
            <input
            style={{ borderRadius: '4px', fontSize: "14px" }}
            className="bodytext"
            type="number"
            name="quantity"
            placeholder="Qty"
            value={newItem.quantity}
            min="1"
            onChange={this.handleChange}
          />
          </div>

          <div style={{ fontSize: "14px" }} className="">
          <input
            style={{ borderRadius: '4px', fontSize: "14px" }}
            className="bodytext"
            type="number"
            name="price"
            placeholder="Price"
            value={newItem.price}
            min="0"
            step="0.01"
            onChange={this.handleChange}
          />
          </div>
          <div className="">
            <button className="btn-primary" onClick={this.addItem}>Add</button>
          </div>
        </div>

        {/* Items table */}
        {items.length > 0 && (
          <table className="" border="1" cellPadding="6" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>Product / Description</th>
                <th>Service Code</th>
                <th>Unit of Measure</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Line Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.productCode} - {item.description}</td>
                  <td>{this.serviceCodeOptions.find(opt => opt.value === item.serviceCode)?.name || item.serviceCode}</td>
                  <td>{this.unitOfMeasureOptions.find(opt => opt.value === item.unitMeasurement)?.name || item.unitMeasurement}</td>
                  <td>{item.quantity}</td>
                  <td>${item.price.toFixed(2)}</td>
                  <td>${(item.quantity * item.price).toFixed(2)}</td>
                  <td>
                    <button className="btn btn-primary mt-1 mb-2" onClick={() => this.removeItem(index)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Total and Save */}
        <div style={{ marginTop: "10px" }}>
          <h3>Total: ${total.toFixed(2)}</h3>
          <button className="btn btn-primary mt-1 mb-2" onClick={this.saveItems} style={{ marginTop: "8px" }}>
            Save Items
          </button>
        </div>
      </div>
    )
  }
}